/** @jsxImportSource @emotion/react */
import React from "react";
import { COMPANY_NAME } from "configs/AppConfig";
import { css } from "@emotion/react";
import {
  TEMPLATE,
  MEDIA_QUERIES,
  DARK_MODE,
  BORDER,
  DARK,
  WHITE,
} from "constants/ThemeConstant";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import IntlMessage from "components/util-components/IntlMessage";

export default function Footer(props) {
  const currentTheme = useSelector((state) => state.theme.currentTheme);
  // const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const maintenance = props?.maintenance || false;
  const { t } = useTranslation();

  return (
    <footer
      css={css`
        height: ${TEMPLATE.FOOTER_HEIGHT}px;
        display: flex;
        position: fixed;
        z-index: 10;
        bottom: 0;
        width: 100%;
        padding: 0 ${TEMPLATE.LAYOUT_CONTENT_GUTTER}px;
        background-color: ${currentTheme === "dark" ? DARK : WHITE};
        align-items: center;
        border-top: 1px solid
          ${currentTheme === "dark"
            ? DARK_MODE.BORDER_BASE_COLOR
            : BORDER.BASE_COLOR};
        justify-content: space-between;

        @media ${MEDIA_QUERIES.MOBILE} {
          position: static !important; /* Footer is NOT sticky */
          height: auto !important; /* Let it expand naturally */
          padding: 16px 12px !important; /* Better spacing on mobile */
          flex-direction: column !important;
          justify-content: center !important;
          text-align: center;

          /* Center text and give spacing */
          span {
            display: block;
            margin-bottom: 10px;
          }

          /* The container that holds your links */
          & > div {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap; /* Allows wrapping (prevents cutting text) */
            justify-content: center;
            align-items: center;
            gap: 8px; /* Spacing between links */
            margin: 0; /* Reset margins */
            width: 100%;
          }

          /* Style only the separators ( | ) */
          & > div span.text-muted {
            margin: 0 4px;
          }

          /* Links should wrap nicely */
          a {
            display: inline-block;
            padding: 4px 0;
            word-break: break-word;
          }
        }
      `}
    >
      <span className="">
        {t("copyright")} &copy; {`${new Date().getFullYear()}`}{" "}
        <span className="font-weight-semibold">{`${COMPANY_NAME}`}</span> {t('allRightsReserved')}
      </span>
      <div className="mt-2 mb-2 mr-50">
        <a
          className="text-gray"
          target="_blank"
          rel="noreferrer"
          href="mailto:feedback@airculinaire.com?subject=Customer Portal - Feedback"
        >
          {t("submitFeedback")}
        </a>
        <span className="mx-2 text-muted"> | </span>
        <a
          className="text-gray"
          target="_blank"
          rel="noreferrer"
          //onClick={() => navigate(`${APP_PREFIX_PATH}/terms-conditions`)}
          href={`${props.baseUrl}/terms-conditions`}
        >
          {t('termsConditions')}
        </a>
        <span className="mx-2 text-muted"> | </span>
        <a
          className="text-gray"
          target="_blank"
          rel="noreferrer"
          href="https://www.airculinaireworldwide.com/legal#dpp"
        >
          {t("privacyPolicy")}
        </a>
        {token && !maintenance && (
          <>
            <span className="mx-2 text-muted"> | </span>
            <a
              className="text-gray"
              target="_blank"
              rel="noreferrer"
              href={`${props.baseUrl}/non-operational-vendors`}
            >
              <IntlMessage id="nonOperationalVendor" />
            </a>
          </>
        )}
      </div>
    </footer>
  );
}
